/**
 * TrendModa — Akıllı Arama + Keşfet Paneli
 * Boş inputta focus → Keşfet paneli (son aramalar + koleksiyonlar + popüler ürünler)
 * Yazıldığında → predictive search sonuçları (ürün + yazım önerileri)
 *
 * Hız: 180ms debounce, AbortController ile eski istek iptali, oturum içi önbellek,
 *      öneri görselleri width parametresiyle küçültülür (tam boyut indirme yapılmaz).
 */
(function () {
  'use strict';

  var input = document.getElementById('tySearchInput');
  var dropdown = document.getElementById('tySearchDropdown');
  if (!input || !dropdown) return;

  var searchForm = document.getElementById('tySearchForm');
  var backBtn = document.getElementById('tySearchBack');
  var debounceTimer;
  var currentQuery = '';
  var controller = null;            // aktif fetch'i iptal etmek için
  var cache = new Map();            // sorgu → sonuç önbelleği (oturum içi)
  var CACHE_MAX = 40;
  var RECENT_KEY = 'ty_recent_searches';
  var RECENT_MAX = 6;

  // Dropdown açık/kapalı durumunu search box'a yansıt
  function syncOpenClass() {
    if (!searchForm) return;
    if (dropdown.style.display === 'block') {
      searchForm.classList.add('ty-search--open');
    } else {
      searchForm.classList.remove('ty-search--open');
    }
  }

  function showDropdown() {
    dropdown.style.display = 'block';
    syncOpenClass();
  }

  function hideDropdown() {
    dropdown.style.display = 'none';
    syncOpenClass();
  }

  // ===== TAM EKRAN MOBİL ARAMA =====
  // Mobilde inputa odaklanınca arama sayfa gibi tam ekran açılır (CSS: .ty-search--fs).
  // ÖNEMLİ: Form body'ye taşınır (reparent). Header zincirinde transform/animation
  // (örn. row2'nin tySearchSlide açılış animasyonu) varken position:fixed viewport'a
  // değil o atalara göre konumlanıyordu — overlay ekranı tam kaplamıyordu.
  var fsPlaceholder = null;
  function isFsViewport() { return window.innerWidth <= 989; }
  function fsOpen() { return searchForm && searchForm.classList.contains('ty-search--fs'); }
  function openFullscreen() {
    if (!searchForm || !isFsViewport() || fsOpen()) return;
    fsPlaceholder = document.createComment('ty-search-fs-placeholder');
    searchForm.parentNode.insertBefore(fsPlaceholder, searchForm);
    document.body.appendChild(searchForm);
    searchForm.classList.add('ty-search--fs');
    document.body.classList.add('ty-search-fs-open');
    // Eski satır-içi çubuk asla ara kare olarak görünmesin
    var row2 = document.querySelector('.ty-header__row2');
    if (row2) row2.classList.remove('is-open');
    // İçerik hemen gelsin (odak beklemeden): sorgu varsa sonuçlar, yoksa Keşfet
    var q = input.value.trim();
    if (q.length >= 2) { fetchSuggestions(q); } else { renderDiscover(); }
    // Taşıma sırasında odak düşer; klavyeyi geri getir
    requestAnimationFrame(function () { input.focus(); });
  }
  function closeFullscreen() {
    if (!searchForm) return;
    searchForm.classList.remove('ty-search--fs');
    document.body.classList.remove('ty-search-fs-open');
    if (fsPlaceholder && fsPlaceholder.parentNode) {
      fsPlaceholder.parentNode.insertBefore(searchForm, fsPlaceholder);
      fsPlaceholder.parentNode.removeChild(fsPlaceholder);
    }
    fsPlaceholder = null;
    hideDropdown();
    input.blur();
    // Header durumunu temizle
    var row2 = document.querySelector('.ty-header__row2');
    if (row2) row2.classList.remove('is-open');
    var tgl = document.getElementById('tyMobileSearchToggle');
    if (tgl) tgl.setAttribute('aria-expanded', 'false');
  }
  // Header'daki arama ikonunun doğrudan tam ekran açabilmesi için dışa açılan API
  window.tySearch = { openFullscreen: openFullscreen, closeFullscreen: closeFullscreen };

  // KRİTİK — bfcache koruması: Kullanıcı tam ekran aramadan bir ürüne gidip GERİ
  // dönerse, tarayıcı sayfayı bfcache'ten aynen geri yükler → overlay açık ve gövde
  // kaydırması kilitli kalır (müşteri "donmuş sayfa" görür ve terk eder).
  // Sayfa her gösterildiğinde ve sayfadan ayrılırken tam ekran durumu temizlenir.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted && fsOpen()) closeFullscreen();
    // persisted olmasa da body kilidi artık kalmışsa temizle (güvenlik ağı)
    if (!fsOpen() && document.body.classList.contains('ty-search-fs-open')) {
      document.body.classList.remove('ty-search-fs-open');
    }
  });
  window.addEventListener('pagehide', function () {
    if (fsOpen()) closeFullscreen();
  });

  // ===== GÖRSEL BOYUTLANDIRMA =====
  // suggest.json ürün görselini TAM BOYUT döndürür; 44px önizleme için
  // CDN'den küçük varyant istenmeli, yoksa mobil megabaytlarca indirir.
  function sizedImage(url, width) {
    if (!url) return '';
    url = String(url);
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  // ===== PARA FORMATLAMA =====
  function parsePrice(val) {
    if (!val && val !== 0) return 0;
    var str = String(val).trim();
    // Eğer nokta veya virgül varsa, zaten bölünmüş/formatlanmış kabul et
    var isDivided = str.includes('.') || str.includes(',');
    var num = parseFloat(str.replace(/[^0-9.-]+/g, ""));
    if (isNaN(num)) return 0;
    return isDivided ? num : num / 100;
  }

  function formatMoney(val) {
    var amount = parsePrice(val);
    var formatted = amount.toFixed(2).replace('.', ',');
    var parts = formatted.split(',');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    formatted = parts.join(',');
    return formatted + ' ₺';
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // ===== SON ARAMALAR =====
  function getRecent() {
    try {
      var r = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
      return Array.isArray(r) ? r : [];
    } catch (_) { return []; }
  }
  function saveRecent(q) {
    q = (q || '').trim();
    if (q.length < 2) return;
    try {
      var r = getRecent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
      r.unshift(q);
      localStorage.setItem(RECENT_KEY, JSON.stringify(r.slice(0, RECENT_MAX)));
    } catch (_) {}
  }
  function clearRecent() {
    try { localStorage.removeItem(RECENT_KEY); } catch (_) {}
  }

  // ===== KEŞFET VERİLERİ (Liquid ile enjekte edilir) =====
  var discoverData = null;
  try {
    var el = document.getElementById('tyDiscoverData');
    if (el) discoverData = JSON.parse(el.textContent);
  } catch (e) { /* ignore */ }

  function productRowHtml(p) {
    var img = sizedImage(p.image || (p.featured_image && p.featured_image.url), 120);
    var pPrice = parsePrice(p.price);
    var pCompare = parsePrice(p.compare_at_price || p.compare_price);
    var priceHtml = '';

    if (pCompare > pPrice) {
      var discountPct = Math.round((1 - pPrice / pCompare) * 100);
      priceHtml = '<span class="ty-search-result__price ty-search-result__price--sale">' + formatMoney(p.price) + '</span>' +
        '<span class="ty-search-result__price ty-search-result__price--compare">' + formatMoney(pCompare) + '</span>';
      if (discountPct > 0) {
        priceHtml += '<span class="ty-search-result__discount-badge">%' + discountPct + '</span>';
      }
    } else {
      priceHtml = '<span class="ty-search-result__price">' + formatMoney(p.price) + '</span>';
    }

    return '<a href="' + p.url + '" class="ty-search-result" data-ty-result>' +
      (img ? '<img class="ty-search-result__img" src="' + img + '" alt="' + escapeHtml(p.title) + '" loading="lazy" width="44" height="44">' : '<div class="ty-search-result__img"></div>') +
      '<div class="ty-search-result__info">' +
        (p.vendor ? '<div class="ty-search-result__vendor">' + escapeHtml(p.vendor) + '</div>' : '') +
        '<div class="ty-search-result__title">' + escapeHtml(p.title) + '</div>' +
        '<div class="ty-search-result__price-wrapper">' + priceHtml + '</div>' +
      '</div></a>';
  }

  // ===== KEŞFET PANELİ =====
  function buildDiscoverHTML() {
    var html = '';

    // Son aramalar
    var recent = getRecent();
    if (recent.length) {
      html += '<div class="ty-discover-section">';
      html += '<div class="ty-discover-section-title">' +
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>' +
        'Son Aramalar' +
        '<button type="button" class="ty-discover-clear" data-ty-clear-recent>Temizle</button></div>';
      html += '<div class="ty-discover-cats">';
      recent.forEach(function (q) {
        html += '<button type="button" class="ty-discover-cat" data-ty-recent-q="' + escapeHtml(q) + '">' +
          '<span class="ty-discover-cat__emoji">🕘</span>' +
          '<span class="ty-discover-cat__name">' + escapeHtml(q) + '</span>' +
        '</button>';
      });
      html += '</div></div>';
    }

    if (!discoverData) return html;

    // Başlık
    html += '<div class="ty-discover-header">' +
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#F27A1A" stroke-width="2"><circle cx="12" cy="12" r="10"/><polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"/></svg>' +
      '<span>Keşfet</span>' +
    '</div>';

    // Koleksiyonlar
    if (discoverData.collections && discoverData.collections.length) {
      html += '<div class="ty-discover-section">';
      html += '<div class="ty-discover-cats">';
      discoverData.collections.forEach(function (c) {
        html += '<a href="' + c.url + '" class="ty-discover-cat">' +
          '<span class="ty-discover-cat__emoji">' + c.emoji + '</span>' +
          '<span class="ty-discover-cat__name">' + escapeHtml(c.title) + '</span>' +
        '</a>';
      });
      html += '</div></div>';
    }

    // Popüler Ürünler
    if (discoverData.popular && discoverData.popular.length) {
      html += '<div class="ty-discover-section">';
      html += '<div class="ty-discover-section-title">' +
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>' +
        'Popüler Ürünler</div>';
      html += '<div class="ty-discover-products">';
      discoverData.popular.forEach(function (p) {
        html += productRowHtml(p);
      });
      html += '</div></div>';
    }

    return html;
  }

  function renderDiscover() {
    var html = buildDiscoverHTML();
    if (!html) { hideDropdown(); return; }
    dropdown.innerHTML = html;
    showDropdown();
  }

  // ===== ARAMA SONUÇLARI =====
  function renderResults(data) {
    var html = '';
    var results = data && data.resources && data.resources.results;

    // Yazım / arama önerileri ("abye" → "abiye")
    if (results && results.queries && results.queries.length) {
      var chips = '';
      results.queries.slice(0, 4).forEach(function (q) {
        if (!q.text || q.text.toLowerCase() === currentQuery.toLowerCase()) return;
        chips += '<button type="button" class="ty-search-query-chip" data-ty-query="' + escapeHtml(q.text) + '">' +
          (q.styled_text || escapeHtml(q.text)) + '</button>';
      });
      if (chips) {
        html += '<div class="ty-search-queries">' + chips + '</div>';
      }
    }

    if (results && results.products && results.products.length) {
      html += '<div class="ty-search-section-title">Ürünler</div>';
      results.products.slice(0, 8).forEach(function (p) {
        html += productRowHtml(p);
      });
      html += '<a href="/search?q=' + encodeURIComponent(currentQuery) + '&type=product&options%5Bprefix%5D=last" class="ty-search-view-all">' +
        '"' + escapeHtml(currentQuery) + '" için tüm sonuçları gör →</a>';
    }

    if (!html) {
      // Çıkmaz sokak yok: bulunamadıysa müşteriyi Keşfet ile aramada tut
      html = '<div class="ty-search-no-results">🔍 "' + escapeHtml(currentQuery) + '" için sonuç bulunamadı</div>' +
        buildDiscoverHTML();
    }

    dropdown.innerHTML = html;
    showDropdown();
  }

  // ===== ARAMA FETCH =====
  function fetchSuggestions(q) {
    currentQuery = q;
    if (q.length < 2) {
      if (controller) { controller.abort(); controller = null; }
      renderDiscover();
      return;
    }

    // Önbellek: aynı sorgu tekrar yazıldıysa ağa çıkma
    var cacheKey = q.toLowerCase();
    if (cache.has(cacheKey)) {
      renderResults(cache.get(cacheKey));
      return;
    }

    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,query' +
      '&resources[limit]=8' +
      '&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][prefix]=last';

    // Skeleton loading (sadece önbellekte yoksa görünür)
    var skeletonHtml = '<div class="ty-search-skeleton">';
    for (var i = 0; i < 5; i++) {
      skeletonHtml += '<div class="ty-search-skeleton__item">' +
        '<div class="ty-search-skeleton__img skeleton-shimmer"></div>' +
        '<div class="ty-search-skeleton__info">' +
          '<div class="ty-search-skeleton__line ty-search-skeleton__line--mid skeleton-shimmer"></div>' +
          '<div class="ty-search-skeleton__line ty-search-skeleton__line--short skeleton-shimmer"></div>' +
        '</div>' +
      '</div>';
    }
    skeletonHtml += '</div>';
    dropdown.innerHTML = skeletonHtml;
    showDropdown();

    // Eski isteği gerçekten iptal et (bant genişliğini yeni isteğe bırak)
    if (controller) controller.abort();
    controller = new AbortController();

    fetch(url, { signal: controller.signal })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (cache.size >= CACHE_MAX) cache.delete(cache.keys().next().value);
        cache.set(cacheKey, data);
        if (currentQuery === q) renderResults(data);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return; // yenisi yolda, dokunma
        hideDropdown();
      });
  }

  // ===== EVENT LISTENERS =====
  input.addEventListener('input', function () {
    clearTimeout(debounceTimer);
    var q = input.value.trim();
    debounceTimer = setTimeout(function () { fetchSuggestions(q); }, 180);
  });

  input.addEventListener('focus', function () {
    openFullscreen();
    var q = input.value.trim();
    if (q.length >= 2) {
      showDropdown();
    } else {
      renderDiscover();
    }
  });

  if (backBtn) {
    backBtn.addEventListener('click', function () {
      closeFullscreen();
    });
  }

  // Dropdown içi tıklamalar: öneri chip'i, son arama, temizle, sonuç linki
  dropdown.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-ty-query]');
    if (chip) {
      var q = chip.getAttribute('data-ty-query');
      input.value = q;
      input.focus();
      saveRecent(q);
      fetchSuggestions(q);
      return;
    }
    var recentBtn = e.target.closest('[data-ty-recent-q]');
    if (recentBtn) {
      var rq = recentBtn.getAttribute('data-ty-recent-q');
      input.value = rq;
      input.focus();
      fetchSuggestions(rq);
      return;
    }
    if (e.target.closest('[data-ty-clear-recent]')) {
      clearRecent();
      renderDiscover();
      return;
    }
    if (e.target.closest('[data-ty-result]')) {
      saveRecent(currentQuery);
      // navigasyon linkin kendisiyle devam eder
    }
    // Dropdown içinden HERHANGİ bir linke tıklanınca tam ekranı kapat ki
    // bfcache anlık görüntüsü temiz kalsın (geri dönüşte kilitli overlay kalmasın).
    if (fsOpen() && e.target.closest('a[href]')) {
      closeFullscreen();
    }
  });

  if (searchForm) {
    searchForm.addEventListener('submit', function () {
      saveRecent(input.value);
    });
  }

  document.addEventListener('click', function (e) {
    if (fsOpen()) return; // tam ekranda dış tıklama yok; geri oku ile kapanır
    if (!input.contains(e.target) && !dropdown.contains(e.target)) {
      hideDropdown();
    }
  });

  input.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (fsOpen()) { closeFullscreen(); return; }
      hideDropdown();
      input.blur();
    }
  });
})();
